import { Row, Rows } from "../../../interfaces";
import { withCellStyles, getCell, formats } from "../../../utils";
import { columnIndexToExcelLetter, headerToColumnLetter } from "../../../utils/functions";
import { BmTemplateInternals, BudgetModalTemplateCurrentState } from "../budget-helper-internal";
import { backgroundGray, boldAndBackgroundGray, textBold } from "../../../excelStyles";

export class AccumulatedCapitalRequiredSection {
  constructor(
    private readonly helper: BmTemplateInternals,
  ) { }

  fillAccumulatedCapitalRequiredRows(rows: Rows, current: BudgetModalTemplateCurrentState): void {
    this.prepareAccumulatedCapitalReq(rows, current);
    this.prepareAccumulatedCapitalReqPcnt(rows, current);
  }

  private prepareAccumulatedCapitalReq(newData: Rows, current: BudgetModalTemplateCurrentState): void {
    const accumulatedCapitalRequired: Row = [];
    accumulatedCapitalRequired.push(withCellStyles('Accumulated capital required', textBold));
    current.headersWithOutTotalTail.forEach((header, headerIndex) => {
      // null header marks an empty narrow column,
      // header can not be undefined
      if (header === null) {
        accumulatedCapitalRequired.push(null);
        return;
      }
      if (header === 'Budget') {
        return;
      }

      const rowIndex = current.rowIndex;
      const style = header.includes('Y') ? boldAndBackgroundGray : textBold;
      const formula = this.getFormulaForAccumulatedTotalReqRow(headerIndex, header, rowIndex);
      accumulatedCapitalRequired.push(withCellStyles(
        getCell({ f: formula, z: formats.thousandsSeparator, t: 'n' }), style)
      );
    });
    const indexOfTotal = current.headersForLogic.indexOf('Total');
    accumulatedCapitalRequired.push(withCellStyles(getCell({
      f: `${columnIndexToExcelLetter(indexOfTotal - 2)}${current.rowIndex}`,
      z: formats.thousandsSeparator, t: 'n',
    }), boldAndBackgroundGray));

    accumulatedCapitalRequired.push(withCellStyles('', backgroundGray));
    this.helper.setCellForTotalPcntOfCommitment(accumulatedCapitalRequired, current.rowIndex, current.indexOfTotalColumn, true);
    newData.push(accumulatedCapitalRequired);
  }

  private prepareAccumulatedCapitalReqPcnt(newData: Rows, current: BudgetModalTemplateCurrentState): void {
    const accumulatedCapitalPcntRequired: Row = [];
    accumulatedCapitalPcntRequired.push(withCellStyles('Accumulated capital required %', textBold));

    current.expandedHeadersWithYear.forEach((headerPcnt) => {
      if (headerPcnt === null) {
        accumulatedCapitalPcntRequired.push(null);
      } else if (headerPcnt !== 'Budget') {
        accumulatedCapitalPcntRequired.push(withCellStyles(getCell({
          f: `IFERROR(${headerToColumnLetter(headerPcnt, current.expandedHeadersWithYear)}${current.rowIndex}/${current.totalCommitment},0)`,
          z: formats.percents, t: 'n',
        }), headerPcnt.includes('Y') ? boldAndBackgroundGray : textBold));
      }
    });

    this.helper.setEmptyTotalsRowWithStyle(accumulatedCapitalPcntRequired);
    newData.push(accumulatedCapitalPcntRequired);
  }

  private getFormulaForAccumulatedTotalReqRow(headerIndex: number, header: string, rowIndex: number): string {
    if (headerIndex === 1) {
      return `${columnIndexToExcelLetter(headerIndex)}${rowIndex - 3}`;
    }
    if (header.includes('Y')) {
      return `${columnIndexToExcelLetter(headerIndex - 1)}${rowIndex}`;
    }
    if (header.includes('Q1')) {
      return `SUM(${columnIndexToExcelLetter(headerIndex)}${rowIndex - 3},${columnIndexToExcelLetter(headerIndex - 2)}${rowIndex})`;
    }
    return `SUM(${columnIndexToExcelLetter(headerIndex)}${rowIndex - 3},${columnIndexToExcelLetter(headerIndex - 1)}${rowIndex})`;
  }
}
